<template>
    <v-date-picker v-bind="$attrs" :value="value" :max="safeMax" :picker-date="pickerDate" v-on="pickerListeners">
        <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
            <slot :name="name" v-bind="slotData" />
        </template>
    </v-date-picker>
</template>

<script>
export default {
    name: 'NvDatePicker',
    inheritAttrs: false,
    props: {
        value: [String, Array],
        max: String,
        pickerDate: String
    },
    data() {
        return { displayedDate: null }
    },
    computed: {
        safeMax() {
            if (this.max) return this.max
            const values = Array.isArray(this.value) ? this.value : [this.value]
            const dates = [...values, this.pickerDate, this.displayedDate]
            // Vuetify lists 100 years ahead by default; five-digit years break its ISO date formatter.
            return dates.some(date => date && Number(date.split('-')[0]) > 9899) ? '9999-12-31' : undefined
        },
        pickerListeners() {
            return {
                ...this.$listeners,
                'update:picker-date': date => {
                    this.displayedDate = date
                    this.$emit('update:picker-date', date)
                }
            }
        }
    }
}
</script>
